import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Navbar = ({ user, onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const isActive = (path) => location.pathname === path ? 'nav-link active' : 'nav-link';

  useEffect(() => { setMenuOpen(false); setDropdownOpen(false); }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    if (dropdownOpen) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [dropdownOpen]);

  const handleLogout = () => {
    setDropdownOpen(false);
    onLogout();
    navigate('/');
  };

  const userInitial = user?.email ? user.email[0].toUpperCase() : '?';

  return (
    <>
      <nav className="nav">
        <div className="nav-container">
          <Link to="/" className="nav-logo">
            <img src="/logo.png" alt="Outsourced" className="nav-logo-img" />
            Outsourced
          </Link>
          <div className="nav-links nav-desktop">
            <Link to="/" className={isActive('/')}>Products</Link>
            <Link to="/order-status" className={isActive('/order-status')}>Order Status</Link>
            <Link to="/reviews" className={isActive('/reviews')}>Reviews</Link>
            <Link to="/docs" className={isActive('/docs')}>Tools Docs</Link>
            <Link to="/terms" className={isActive('/terms')}>Terms</Link>
            {user ? (
              <div className="nav-user-menu" ref={dropdownRef}>
                <button
                  className="nav-avatar-btn"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  aria-label="User menu"
                >
                  <span className="nav-avatar">{userInitial}</span>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ transition: 'transform 0.2s', transform: dropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}><polyline points="6 9 12 15 18 9"/></svg>
                </button>

                {dropdownOpen && (
                  <div className="nav-dropdown">
                    <div className="nav-dropdown-header">
                      <span className="nav-dropdown-avatar">{userInitial}</span>
                      <div>
                        <div className="nav-dropdown-email">{user.email}</div>
                        <div className="nav-dropdown-balance">${(user.balance || 0).toFixed(2)} balance</div>
                      </div>
                    </div>
                    <div className="nav-dropdown-divider" />
                    <Link to="/dashboard" className="nav-dropdown-item" onClick={() => setDropdownOpen(false)}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="9"/><rect x="14" y="3" width="7" height="5"/><rect x="14" y="12" width="7" height="9"/><rect x="3" y="16" width="7" height="5"/></svg>
                      Dashboard
                    </Link>
                    <Link to="/dashboard" className="nav-dropdown-item" onClick={() => { setDropdownOpen(false); setTimeout(() => window.dispatchEvent(new CustomEvent('nav-tab', { detail: 'buy' })), 50); }}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
                      Purchase Boosts
                    </Link>
                    <Link to="/dashboard" className="nav-dropdown-item" onClick={() => { setDropdownOpen(false); setTimeout(() => window.dispatchEvent(new CustomEvent('nav-tab', { detail: 'orders' })), 50); }}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                      Order History
                    </Link>
                    <Link to="/dashboard" className="nav-dropdown-item" onClick={() => { setDropdownOpen(false); setTimeout(() => window.dispatchEvent(new CustomEvent('nav-tab', { detail: 'addbal' })), 50); }}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>
                      Add Balance
                    </Link>
                    <Link to="/dashboard" className="nav-dropdown-item" onClick={() => { setDropdownOpen(false); setTimeout(() => window.dispatchEvent(new CustomEvent('nav-tab', { detail: 'api' })), 50); }}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
                      API Access
                    </Link>
                    <Link to="/dashboard" className="nav-dropdown-item" onClick={() => { setDropdownOpen(false); setTimeout(() => window.dispatchEvent(new CustomEvent('nav-tab', { detail: 'referral' })), 50); }}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>
                      Referrals
                    </Link>
                    <Link to="/dashboard" className="nav-dropdown-item" onClick={() => { setDropdownOpen(false); setTimeout(() => window.dispatchEvent(new CustomEvent('nav-tab', { detail: 'reboost' })), 50); }}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 4v6h-6"/><path d="M1 20v-6h6"/><path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/></svg>
                      Auto-Reboost
                    </Link>
                    <Link to="/dashboard" className="nav-dropdown-item" onClick={() => { setDropdownOpen(false); setTimeout(() => window.dispatchEvent(new CustomEvent('nav-tab', { detail: 'tickets' })), 50); }}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
                      Support
                    </Link>
                    <div className="nav-dropdown-divider" />
                    <button className="nav-dropdown-item nav-dropdown-logout" onClick={handleLogout}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                      Sign Out
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <Link to="/login" className="nav-link nav-login-btn">Sign In</Link>
            )}
          </div>
          <button
            className={'nav-hamburger' + (menuOpen ? ' open' : '')}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>
      {menuOpen && (
        <div className="nav-mobile-overlay" onClick={() => setMenuOpen(false)}>
          <div className="nav-mobile-menu" onClick={e => e.stopPropagation()}>
            <Link to="/" className={isActive('/')}>Products</Link>
            <Link to="/order-status" className={isActive('/order-status')}>Order Status</Link>
            <Link to="/reviews" className={isActive('/reviews')}>Reviews</Link>
            <Link to="/docs" className={isActive('/docs')}>Docs</Link>
            <Link to="/terms" className={isActive('/terms')}>Terms</Link>
            <div className="nav-mobile-divider"></div>
            {user ? (
              <>
                <div className="nav-mobile-user-info">
                  <span className="nav-avatar" style={{ width: 32, height: 32, fontSize: '0.8rem' }}>{userInitial}</span>
                  <div>
                    <div style={{ fontSize: '0.82rem', color: 'var(--text-primary)', fontWeight: 500 }}>{user.email}</div>
                    <div style={{ fontSize: '0.72rem', color: 'var(--accent)' }}>${(user.balance || 0).toFixed(2)} balance</div>
                  </div>
                </div>
                <Link to="/dashboard" className="nav-link" onClick={() => setMenuOpen(false)}>Dashboard</Link>
                <Link to="/dashboard" className="nav-link" onClick={() => { setMenuOpen(false); setTimeout(() => window.dispatchEvent(new CustomEvent('nav-tab', { detail: 'buy' })), 50); }}>Purchase Boosts</Link>
                <Link to="/dashboard" className="nav-link" onClick={() => { setMenuOpen(false); setTimeout(() => window.dispatchEvent(new CustomEvent('nav-tab', { detail: 'reboost' })), 50); }}>Auto-Reboost</Link>
                <Link to="/dashboard" className="nav-link" onClick={() => { setMenuOpen(false); setTimeout(() => window.dispatchEvent(new CustomEvent('nav-tab', { detail: 'orders' })), 50); }}>Order History</Link>
                <Link to="/dashboard" className="nav-link" onClick={() => { setMenuOpen(false); setTimeout(() => window.dispatchEvent(new CustomEvent('nav-tab', { detail: 'api' })), 50); }}>API Access</Link>
                <div className="nav-mobile-divider"></div>
                <button className="nav-mobile-logout" onClick={() => { setMenuOpen(false); handleLogout(); }}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                  Sign Out
                </button>
              </>
            ) : (
              <Link to="/login" className="nav-link nav-login-btn">Sign In</Link>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
